
    var riot = require('riot')
    //src: starling/src/tags/floating-tooltip.html
riot.tag2('floating-tooltip',
  '<span if="{tip}" class="floating-tooltip_tip">{tip}</span>',
  '',
  'show="{summoned}" class="floating-tooltip floating-tooltip--{position} floating-tooltip--{alignment}" riot-style="left: {left}px; top: {top}px"', function(opts) {
'use strict';

var _this = this;

var _opts = opts,
    canvas = _opts.canvas;

var reset = function reset() {
  return Object.assign(_this, { referenceEl: null, summoned: false, tip: '', left: 0, top: 0 });
};

canvas.floatingTooltip = this;

reset();

this.positionSelf = function (_ref) {
  var referenceEl = _ref.referenceEl,
      _ref$position = _ref.position,
      position = _ref$position === undefined ? 'above' : _ref$position,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === undefined ? 'center' : _ref$alignment;

  var _referenceEl$getBound = referenceEl.getBoundingClientRect(),
      left = _referenceEl$getBound.left,
      right = _referenceEl$getBound.right,
      top = _referenceEl$getBound.top;

  Object.assign(_this, { top: top, left: left + (right - left) / 2, position: position, alignment: alignment });
};

this.summon = function (_ref2) {
  var tip = _ref2.tip,
      referenceEl = _ref2.referenceEl,
      position = _ref2.position,
      alignment = _ref2.alignment;

  Object.assign(_this, { tip: tip, referenceEl: referenceEl, summoned: true });
  _this.positionSelf({ referenceEl: referenceEl, position: position, alignment: alignment });
  _this.update();
};

this.hide = function () {
  reset();
  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('floating-tooltip')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/floating-tooltip.html
// module id = 798
// module chunks = 0